// data editor change type constants
export const DATA_EDITOR_SET = 'set' as const;
export const DATA_EDITOR_UNSET = 'unset' as const;
export const DATA_EDITOR_UPDATE = 'update' as const;
export const DATA_EDITOR_BATCH_UPDATE = 'batch_update' as const;
export const DATA_EDITOR_ADD_ROW = 'add_row' as const;
export const DATA_EDITOR_DELETE_ROWS = 'delete_rows' as const;

export type DataEditorActionType =
  | typeof DATA_EDITOR_SET
  | typeof DATA_EDITOR_UNSET
  | typeof DATA_EDITOR_UPDATE
  | typeof DATA_EDITOR_BATCH_UPDATE
  | typeof DATA_EDITOR_ADD_ROW
  | typeof DATA_EDITOR_DELETE_ROWS;
